<template>
  <div>
    <v-container >
      <v-row class="elevation-1">
        <v-col>
          <v-select id="input-text-size"
          class="input-text-size"
            v-model="reportConfig"
            :items="reports"
            item-text="description"
            item-value="config"
            label="Type of report"
          ></v-select>
        </v-col>
      </v-row>

      <v-row class="elevation-1"
        v-if="showReportConfig('showWorkstation')">
        <v-col>
          <SimpleMultiSelect
            id="tmc-tax-payment-by-wkst"
            label="By Workstation"
            :items="criteria.wkst"
            :item-list="wkstNumList"
            @selected-items="selectedWkstList"
          />
          </v-col>
      </v-row>
      <v-row class="elevation-1" v-if="showReportConfig('showExcludeWorkstation')">
        <v-col>

          <SimpleMultiSelect
            id="tmc-tax-payment-exclude-wkst"
            label="Exclude Workstation"
            :items="criteria.excludedWkst"
            :item-list="wkstNumList"
            @selected-items="selectedExcludedWkstList"
          />
          </v-col>
      </v-row>
      <v-row class="elevation-1"
        v-if="showReportConfig('showTaxYears')">
        <v-col cols="6">
          <v-select
                class="input-text-size"
                :items="taxYearList"
                label="From Tax Year"
                item-text="name"
                item-value="value"
                v-model.number="criteria.fromTaxYear"
                @input="searchByCriteria"
              ></v-select>
        </v-col>
        <v-col cols="6">
          <v-select
          class="input-text-size"
                :items="taxYearList"
                label="To Tax Year"
                item-text="name"
                item-value="value"
                v-model.number="criteria.toTaxYear"
                @input="searchByCriteria"
              ></v-select>

        </v-col>
      </v-row>
      <v-row class="elevation-1"
        v-if="showReportConfig('showDate')">
        <v-col cols="6">
              <ClarionDateControl
                :isRequired="true"
                label="Date"
                v-model="criteria.fromDate"
                :isToggle="false"
              />
        </v-col>
      </v-row>
      <v-row class="elevation-1"
        v-if="showReportConfig('showDateRange')">
        <v-col cols="6">
              <ClarionDateControl
                :isRequired="true"
                label="From Date"
                v-model="criteria.fromDate"
                :isToggle="false"
              />
        </v-col>
        <v-col cols="6">
          <ClarionDateControl
            :isRequired="true"
            label="To Date"
            v-model="criteria.toDate"
            :isToggle="false"
          />
        </v-col>
      </v-row>
      <v-row class="elevation-1" v-if="showReportConfig('showcCCDate')">
        <v-col cols="12">
          <v-radio-group
            v-model="selectedDateType"
            row
            dense
            hide-details
            @change="changeDateType"
          >
            <v-radio
              label="CC Date"
              value="cc"
              color="primary"
            ></v-radio>
            <v-radio
              label="Business Date"
              value="business"
              color="primary"
            ></v-radio>
            <v-radio
              label="Payment Date"
              value="payment"
              color="primary"
            ></v-radio>
          </v-radio-group>
        </v-col>
    </v-row>
      <v-row class="elevation-1" v-if="showReportConfig('showcCCDate')
       && selectedDateType === 'cc'">
        <v-col cols="6">
              <ClarionDateControl
                :isRequired="true"
                label="From CC Date"
                v-model="criteria.fromCCDate"
                :isToggle="false"
              />
        </v-col>
        <v-col cols="6">
          <ClarionDateControl
            :isIsoDate=true
            label="To CC Date"
            v-model="criteria.toCCDate"
            :isToggle="false"
          />
        </v-col>
      </v-row>
      <v-row class="elevation-1"
        v-if="showReportConfig('showSystemDate') && selectedDateType === 'business'">
        <v-col cols="6">
              <ClarionDateControl
                :isRequired="true"
                label="From Business Date"
                v-model="criteria.fromSystemDate"
                :isToggle="false"
              />
        </v-col>
        <v-col cols="6">
          <ClarionDateControl
            :isIsoDate=true
            label="To Business Date"
            v-model="criteria.toSystemDate"
            :isToggle="false"
          />
        </v-col>
      </v-row>

      <v-row class="elevation-1"
        v-if="showReportConfig('showcCCDate') && selectedDateType === 'payment'">
        <v-col cols="6">
              <ClarionDateControl
                :isRequired="true"
                label="From Payment Date"
                v-model="criteria.fromPaymentDate"
                :isToggle="false"
              />
        </v-col>
        <v-col cols="6">
          <ClarionDateControl
            :isIsoDate=true
            label="To Payment Date"
            v-model="criteria.toPaymentDate"
            :isToggle="false"
          />
        </v-col>
      </v-row>

      <v-row class="elevation-1"
        v-if="showReportConfig('showTaxYear')"
        >
       <v-col>
          <MultiItemSelect id="tmc-payment-report-by-transaction"
            label="By Tax year"
            item-text="val"
            item-value="val"
            :item-list="formattedTaxYearData"
            :items="criteria.taxYears"
            @selected-items="selectedTaxYearList"
          />
          </v-col>
      </v-row>

      <v-row class="elevation-1"
        v-if="showReportConfig('showTransactionType')"
        >
        <v-col>
          <MultiItemSelect id="tmc-payment-report-by-transaction"
            label="By Transaction"
            item-text="name"
            item-value="value"
            :item-list="transactionIdList"
            :items="criteria.transactionType"
            @selected-items="selectedTransactionTypeList"
          />
          </v-col>
      </v-row>

      <v-row class="elevation-1"
        v-if="showReportConfig('showSpecialPaymentType')"
        >
        <v-col>
          <MultiItemSelect id="tmc-payment-report-by-transaction"
            label="By Payment"
            item-text="description"
            item-value="name"
            :item-list="specialPaymentTypesList"
            :items="criteria.specialPaymentType"
            @selected-items="selectedSpecialPaymentTypeList"
          />
          </v-col>
      </v-row>

      <v-row class="elevation-1"
        v-if="showReportConfig('showPaymenttype')"
        >
        <v-col>
          <MultiItemSelect
          class="input-text-size"
            label="By Payment type"
            item-text="description"
            item-value="name"
            :item-list="paymentIdList"
            :items="criteria.paymentType"
            @selected-items="selectedPaymentTypeList"
          />
          </v-col>
      </v-row>

      <v-row class="elevation-1"
        v-if="showReportConfig('showPaymentMode')"
        >
        <v-col>
          <MultiItemSelect
          class="input-text-size"
            label="By Payment Mode"
            item-text="description"
            item-value="name"
            :item-list="paymentModeList"
            :items="criteria.paymentModeList"
            @selected-items="selectedPaymentModeList"
          />
          </v-col>
      </v-row>
      <v-row class="elevation-1"
        v-if="showReportConfig('showTaxType')"
        >
        <v-col>
          <MultiItemSelect
          class="input-text-size"
            label="By Tax type"
            item-text="description"
            item-value="name"
            :item-list="TaxTypeEnum"
            :items="criteria.taxTypes"
            @selected-items="selectedTaxTypes"
          />
          </v-col>
      </v-row>

      <v-row class="elevation-1"
        v-if="showReportConfig('showPaymentType')"
        >
        <v-col>
          <MultiItemSelect
          class="input-text-size"
            label="By Payment type"
            item-text="label"
            item-value="value"
            :item-list="paymentStatusCode"
            :items="criteria.cmnPaymentTypes"
            @selected-items="selectedCmnPaymentTypes"
          />
          </v-col>
      </v-row>

      <v-row class="elevation-1"
        v-if="showReportConfig('showPaymenttypeWithoutTaxPayment')"
        >
        <v-col>
          <MultiItemSelect
          class="input-text-size"
            label="By Payment type"
            item-text="label"
            item-value="value"
            :item-list="paymentWithoutTaxPaymentIdList"
            :items="criteria.paymentTypeWithoutTaxPayment"
            @selected-items="selectedPaymentTypeListWithoutTaxPayment"
          />
          </v-col>
      </v-row>

      <v-row class="elevation-1"
        v-if="showReportConfig('showTaxFees')">
        <v-col>
          <MultiItemSelect
            label="By Fund"
            item-text="taxFeesCodeAndName"
            item-value="feeNumber"
            :item-list="taxFeesList"
            :items="criteria.taxFees"
            @selected-items="selectedTaxFees"
          />
        </v-col>
      </v-row>

      <v-row class="elevation-1"
        v-if="showReportConfig('showTaxDistricts')">
        <v-col>
          <MultiItemSelect
            label="By Tax Districts"
            item-text="taxDistrictCodeAndName"
            item-value="districtCode"
            :item-list="taxDistrictList"
            :items="criteria.taxDistricts"
            @selected-items="selectedTaxDistricts"
          />
        </v-col>
      </v-row>

      <v-row class="elevation-1"
        v-if="showReportConfig('showTaxStatusCodes')">
        <v-col>
          <MultiItemSelect
            label="Tax Status"
            class="input-text-size"
            item-text="taxStatusCodeAndName"
            item-value="statusCode"
            :item-list="taxStatusList"
            :items="criteria.taxStatusList"
            @selected-items="selectedTaxStatus"
          />
        </v-col>
      </v-row>
      <v-row class="elevation-1">
        <v-col cols="3"
          id="tmc-tax-overpayment-show-assign"
          v-if="showReportConfig('showAssignedUser')">
          <MultiItemSelect
          class="input-text-size"
            label="By Assign To"
            item-text="fullname"
            item-value="username"
            :item-list="assignUsersList"
            :items="criteria.assignedTo"
            @selected-items="selectedUsers"
          />

        </v-col>
        <v-col cols="2"
          id="tmc-tax-overpayment-show-unresolved"
          v-if="showReportConfig('showUnresolved')">
          <v-checkbox
            v-model="criteria.showUnresolved"
            label="Show Unresolved Only"
            class="input-text-size pt-4">
          </v-checkbox>
        </v-col>
      </v-row>
     <v-row class="elevation-1">
        <v-col cols="2"
          id="tmc-misc-report-print-details"
          v-if="showReportConfig('showPrintDetails')">
          <v-checkbox
            v-model="criteria.printDetails"
            label="Print Details"
            class="input-text-size">
          </v-checkbox>
        </v-col>
        <v-col cols="2"
          id="tmc-misc-report-print-csv"
          v-if="showReportConfig('showDownloadCsv')">
          <v-checkbox
            v-model="criteria.tocsv"
            label="Print to CSV"
            class="input-text-size">
          </v-checkbox>
        </v-col>
        <v-col cols="2"
          id="tmc-misc-report-print-details"
          v-if="showReportConfig('showIncludeAdjustment') || showReportConfig('showIncludeAdjustments')">
          <v-checkbox
            v-model="criteria.includeAdjustment"
            label="Include adjustments"
            class="input-text-size">
          </v-checkbox>
        </v-col>
        <v-col cols="2"
          id="tmc-misc-report-print-full-desc"
          v-if="showReportConfig('showPrintOSOnly')">
          <v-checkbox
            v-model="criteria.isPrintOSOnly"
            label="Print Outstanding Only"
            class="input-text-size">
          </v-checkbox>
        </v-col>
        <v-col cols="3"
          id="tmc-tp-report-as-of-date"
          v-if="showReportConfig('showPrintOSOnly')">
          <ClarionDateControl
            label="As Of Date"
            v-model="criteria.asOfDate"
            :isDisabled="!criteria.isPrintOSOnly"
            :isRequired="criteria.isPrintOSOnly"
            :isToggle="false"
          />
        </v-col>
        <v-col cols="2"
          id="tmc-misc-report-print-full-desc"
          v-if="showReportConfig('showPrintFullDesc')">
          <v-checkbox
            v-model="criteria.printFullDesc"
            label="Print Full Desc."
            class="input-text-size">
          </v-checkbox>
        </v-col>
        <v-col cols="2"
        id="tmc-voided-result-details"
        v-if="showReportConfig('showVoidedDetails')"
        >
         <v-checkbox
            v-model="criteria.printVoidDetails"
            label="Print report with details"
            class="input-text-size">
          </v-checkbox>
        </v-col>
      </v-row>
      <v-row class="elevation-1">
        <v-col cols="2"
          id="tmc-tp-report-print-voids"
          v-if="showReportConfig('showMailOnly')">
          <v-checkbox
            v-model="criteria.printMail"
            label="Print Mail Only"
            class="input-text-size">
          </v-checkbox>
        </v-col>
        <v-col cols="2"
          id="tmc-tp-report-print-voids"
          v-if="showReportConfig('showVoidsOnly')">
          <v-checkbox
            v-model="criteria.printVoids"
            label="Print Voids"
            class="input-text-size">
          </v-checkbox>
        </v-col>
        <v-col cols="2"
          id="tmc-tp-report-print-exempt-mfg"
          v-if="showReportConfig('showExemptMfgOnly')">
          <v-checkbox
            v-model="criteria.printExemptMfg"
            label="Print Exempt Mfg"
            class="input-text-size">
          </v-checkbox>
        </v-col>
      </v-row>
      <v-row class="elevation-1"
        v-if="showReportConfig('showStatusTaxType')">
        <v-col>
          <MultiItemSelect
            class="input-text-size"
            label="Tax Type"
            item-text="label"
            item-value="value"
            :item-list="taxStatusTypeList"
            :items="criteria.taxStatusType"
            @selected-items="selectedTaxStatusTypeList"
          />
        </v-col>
      </v-row>
      <v-row class="align-center">
        <ReportChip
          :to="reportConfig.route"
          :queryString="queryString"
          :isValid="validateCriteria"
          caption="View Report"
        />
        <AddToCronJobBtn
          v-if="reportConfig.route"
          :destination="reportConfig.route"
          :params="currentCronParams"
        />
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {
  mapActions, mapGetters,
  mapState,
} from 'vuex';
import { getRawJwt } from '../../../../util/jwt';
import { toShortDate } from '../../../../util/shared/tmc-global';
import { amountToNumber } from '../../../../util/shared/vue-global';
import { getWorkstationNumber } from '../../../../util/workstation-util';
import ClarionDateControl from '../../../common/ClarionDateControl.vue';
import MultiItemSelect from '../../../common/base/MultiItemSelect.vue';
import SimpleMultiSelect from '../../../common/base/SimpleMultiSelect.vue';
import ReportChip from '../../../reports/ReportChip.vue';
import AddToCronJobBtn from '../../../common/AddToCronJobBtn.vue';
import { queryStringCalc, reportList, buildCronParams } from './report-util';

const taxDistrictBaseCrudKey = 'sharedTaxDistrict';
const taxFeeMAsterBaseCrudKey = 'sharedTaxFeeMaster';

export default {
  name: 'TaxPaymentReportComp',
  components: {
    ReportChip,
    AddToCronJobBtn,
    ClarionDateControl,
    MultiItemSelect,
    SimpleMultiSelect,
  },
  data: () => ({
    wkstNumber: getWorkstationNumber(),
    taxYearRange: [],
    criteria: {
      fromDate: undefined,
      toDate: undefined,
      fromCCDate: undefined,
      toCCDate: undefined,
      fromSystemDate: undefined,
      toSystemDate: undefined,
      fromPaymentDate: undefined,
      toPaymentDate: undefined,
      asOfDate: undefined,
      fromTaxYear: undefined,
      toTaxYear: undefined,
      taxYears: [],
      printDetails: false,
      printFullDesc: false,
      printVoids: false,
      printMail: false,
      printExemptMfg: false,
      isPrintOSOnly: false,
      printVoidDetails: false,
      wkst: [],
      paymentType: [],
      paymentTypeWithoutTaxPayment: [],
      transactionType: [],
      taxDistricts: [],
      taxFees: [],
      specialPaymentType: [],
      taxTypes: [],
      taxStatusList: [],
      paymentModeList: [],
      assignedTo: [],
      paymentStatusCode: [],
      paymentWithoutTaxPaymentIdList: [],
      cmnPaymentTypes: [],
      tocsv: false,
      excludedWkst: [],
      taxStatusType: [],
    },
    transactionTypeList: [
      {
        name: 'Tax Payments',
        value: 'taxpayments',
      },
      {
        name: 'Mortgage Tax',
        value: 'mtgTransaction',
      },
      {
        name: 'Miscellaneous Receipts',
        value: 'miscTransaction',
      },
    ],
    assignUsersList: [],
    // wkstList: [],
    reportConfig: {
      route: '',
      filters: {},
    },
    criteriaStats: {
      allWkst: false,
      allTaxDistricts: false,
      allPaymentTypes: false,
      allTrasactionType: false,
      allTaxFees: false,
      allSpecialPaymentType: true,
      alltaxYears: false,
      allTaxTypes: false,
      allTaxStatus: false,
      allPaymentModes: false,
    },
    defaultCriteria: {
      fy: undefined,
    },
    selectedDateType: 'cc',
  }),

  created() {
    this.loadWorkStationNumbers();
    this.loadTaxDistricts();
    this.initCriteria();
    this.loadTransactionType();
    this.loadTaxfeeMaster();
    this.loadLatestCCDateFromCC();
    this.loadTaxYear();
    this.loadPaymentType();
    this.loadPaymentTypeWithoutTaxPayment();
    this.loadTaxType();
    this.loadTaxStatusType();
    this.loadTaxStatusList();
    this.loadPaymentModes();
    this.loadUsersList();
    this.loadCmnPaymentTypes();

    // Load enum data first, then set special payment type defaults
    this.$nextTick(() => {
      this.loadSpecialPaymentType();
    });
  },
  computed: {
    ...mapGetters('base/crud', [
      'items',
    ]),
    ...mapState({
      wkstNumList: (state) => state.tax.taxPayment.paymentWkstNumList || [],
      statusTypes: (state) => state.enums.TaxPaymentEnum || [],
      taxYearList: (state) => state.tax.taxCommon.taxYearList || [],
      TaxTypeEnum: (state) => state.enums.TaxTypeEnum || [],
      PaymentTypeEnum: (state) => state.enums.TaxPaymentEnum || [],
      specialPaymentTypes: (state) => state.enums.TaxCCSpecialPaymentTypeEnum || [],
      TaxPaymentModesEnum: (state) => state.enums.TaxPaymentModesEnum || [],
      paymentSettingItem: (state) => state.SystemConfig.paymentSettingItem || {},
      cmnPaymentTypes: (state) => state.enums.TaxPaymentEnum || [],
    }),
    reports() {
      return [
        ...reportList(),
      ];
    },
    taxStatusTypeList() {
      return this.statusTypes.map((el, index) => ({
        label: `${index + 1} ${el.description}`,
        value: el.name,
      }));
    },
    queryString() {
      return queryStringCalc({
        reportConfig: this.reportConfig,
        criteria: this.criteria,
        token: this.getAuthToken,
        defaultCriteria: this.defaultCriteria,
        devSetting: this.devSettingItem,
        criteriaStats: this.criteriaStats,
        selectedDateType: this.selectedDateType,
        assignUsersList: this.assignUsersList,
      });
    },
    validateCriteria() {
      let isValid = true;
      if (this.criteria.fy == null) {
        isValid = false;
      }
      return isValid;
    },
    getAuthToken() {
      return getRawJwt();
    },
    wkstIdLists() {
      const wkstNoList = (this.wkstNumList || []);
      return wkstNoList;
    },
    taxStatusList() {
      const items = this.items('TaxRollStatusCodes');
      const updatedItem = items.map((i) => ({
        ...i,
        taxStatusCodeAndName: `${i.statusCode} ${i.description || ''}`,
      })).sort((a, b) => Number(a.statusCode) - Number(b.statusCode));
      return [...updatedItem];
    },
    specialPaymentTypesList() {
      const specialPaymentTypesData = (this.specialPaymentTypes || []);
      return specialPaymentTypesData;
    },
    taxYearData() {
      const taxYears = (this.taxYearList || []);
      return taxYears;
    },
    formattedTaxYearData() {
      const taxYears = (this.taxYearList || []).map((ft) => ({ val: ft }));
      return taxYears;
    },
    paymentIdList() {
      const paymentTypeList = (this.PaymentTypeEnum || []);
      return paymentTypeList;
    },
    paymentModeList() {
      const paymentModeList = (this.TaxPaymentModesEnum || []);
      return paymentModeList;
    },
    transactionIdList() {
      const transactionType = (this.transactionTypeList || []);
      return transactionType;
    },
    taxTypeIdList() {
      const taxTypeList = (this.TaxTypeEnum || []);
      return taxTypeList;
    },
    taxDistrictList() {
      const items = this.items(taxDistrictBaseCrudKey);
      const updatedItem = items.map((i) => ({
        ...i,
        taxDistrictCodeAndName: `${i.districtCode} ${i.districtName || ''}`,
      }));
      return [...updatedItem];
    },
    taxFeesList() {
      const items = this.items(taxFeeMAsterBaseCrudKey);
      const updatedItem = items.map((i) => ({
        ...i,
        taxFeesCodeAndName: `${i.feeDescription} ${i.feeNumber || ''}`,
      }));

      return [...updatedItem];
    },
    editCCDate: {
      get() {
        return this.isCCDate;
      },
      set(value) {
        this.isCCDate = value;
      },
    },
    currentCronParams() {
      return buildCronParams({
        reportConfig: this.reportConfig,
        criteria: this.criteria,
        criteriaStats: this.criteriaStats,
        selectedDateType: this.selectedDateType,
        assignUsersList: this.assignUsersList,
      });
    },
  },
  watch: {
    specialPaymentTypes: {
      handler(newVal) {
        // When specialPaymentTypes data becomes available, set default selections
        if (newVal && newVal.length > 0 && this.criteria.specialPaymentType.length === 0) {
          this.loadSpecialPaymentType();
        }
      },
      immediate: true,
    },
    statusTypes: {
      handler(newVal) {
        if (newVal && newVal.length > 0 && this.criteria.taxStatusType.length === 0) {
          this.loadTaxStatusType();
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions('SystemConfig', [
      'loadConfig',
    ]),
    ...mapActions('tax/taxPayment', [
      'loadPaymentsWkstList',
    ]),

    ...mapActions('shared/taxDistrict', [
      'loadTaxDistrict',
    ]),
    ...mapActions('tax/taxCommon', [
      'loadTaxYearList',
    ]),
    ...mapActions('shared/taxFeeMaster', [
      'loadTaxFeeMasterTypes',
    ]),
    ...mapActions('tax/ccPayments', [
      'loadLatestCCDate',
    ]),
    ...mapActions('shared/taxStatusCodesShared', [
      'loadTaxStatusCodesSharedRecords',
    ]),
    ...mapActions('UserAdministration', [
      'loadUsers',
    ]),
    searchByCriteria() {

    },
    async loadUsersList() {
      const users = await this.loadUsers();
      const taxUsers = [];
      // eslint-disable-next-line array-callback-return, consistent-return
      (users || []).map((item) => {
        const { roles } = item;
        if (roles.includes('TAXADMINISTRATION') || roles.includes('TAXUSER')) {
          taxUsers.push({ fullname: item.fullname, username: item.username });
        }
      });
      taxUsers.sort((a, b) => (a.fullname || '').localeCompare(b.fullname || ''));
      this.assignUsersList = taxUsers;
      this.criteria.assignedTo = taxUsers.map((u) => u.username);
    },
    async loadCmnPaymentTypes() {
      const allCmnPaymentTypes = (this.cmnPaymentTypes || []);
      const allPaymentTypes = [];
      const itemList = [];
      // eslint-disable-next-line array-callback-return
      allCmnPaymentTypes.map((item, key) => {
        allPaymentTypes.push({ value: item.name, label: `${key + 1} ${item.name}` });
        itemList.push(item.name);
      });
      this.paymentStatusCode = allPaymentTypes;
      this.criteria.cmnPaymentTypes = itemList;
    },
    mapCollectionVal(itemList, itemValue) {
      return [...(itemList || []).map((item) => item[`${itemValue}`])];
    },
    selectedTransactionTypeList(val) {
      this.criteria.transactionType = val;
      this.criteriaStats.allTrasactionType = (val || []).length === this.transactionIdList.length;
    },
    loadSpecialPaymentType() {
      // Only proceed if specialPaymentTypesList has data
      if (this.specialPaymentTypesList && this.specialPaymentTypesList.length > 0) {
        this.criteria.specialPaymentType = this.mapCollectionVal(this.specialPaymentTypesList, 'name');
        this.criteriaStats.allSpecialPaymentType = true;
      }
    },
    selectedSpecialPaymentTypeList(val) {
      this.criteria.specialPaymentType = val;
      const val2 = (val || []).length === this.specialPaymentTypesList.length;
      this.criteriaStats.allSpecialPaymentType = val2;
    },
    selectedUsers(val) {
      this.criteria.assignedTo = val;
    },
    selectedTaxYearList(val) {
      this.criteria.taxYears = val;
      const val2 = (val || []).length === this.taxYearData.length;
      this.criteriaStats.alltaxYears = val2;
    },
    selectedPaymentTypeList(val) {
      this.criteria.paymentType = val;
      /* update stats */
      this.criteriaStats.allPaymentTypes = (val || []).length === this.paymentType.length;
    },
    selectedPaymentTypeListWithoutTaxPayment(val) {
      this.criteria.paymentTypeWithoutTaxPayment = val;
      this.criteriaStats.allPaymentTypes = (val || []).length
       === this.paymentTypeWithoutTaxPayment.length;
    },
    selectedPaymentModeList(val) {
      this.criteria.paymentModeList = val;
      /* update stats */
      this.criteriaStats.allPaymentModes = (val || []).length === this.paymentModeList.length;
    },
    showReportConfig(configField) {
      return this.reportConfig.filters[`${configField}`];
    },
    async loadWorkStationNumbers() {
      await this.loadConfig({ requiredScope: 'paymentConfig' });
      this.loadPaymentsWkstList().then(() => {
        if (this.paymentSettingItem.autoSelectWkstOnPaymentReports) {
          this.criteria.wkst = [amountToNumber(this.wkstNumber)];
          this.criteriaStats.allWkst = false;
        } else {
          this.criteria.wkst = this.wkstIdLists;
          this.criteriaStats.allWkst = true;
        }
        // Load excluded workstations after payment config is loaded
        this.loadExcludedWorkstations();
      });
    },
    async loadTaxYear() {
      const criteria = {};
      this.loadTaxYearList({ criteria, baseCrudKey: taxDistrictBaseCrudKey }).then(() => {
        this.criteria.taxYears = this.taxYearData;
        this.criteriaStats.alltaxYears = true;
        this.criteria.fromTaxYear = (this.taxYearData[0] || {});
        this.criteria.toTaxYear = (this.taxYearData[0] || {});
      });
    },
    async loadTaxStatusList() {
      const criteria = {};
      this.loadTaxStatusCodesSharedRecords({
        criteria,
        baseCrudKey: 'TaxRollStatusCodes',
      }).then(() => {
        this.criteria.taxStatusList = this.mapCollectionVal(this.taxStatusList, 'statusCode');
        /* Set select-all */
        this.criteriaStats.allTaxStatus = true;
      });
    },
    selectedWkstList(val) {
      this.criteria.wkst = val;
      /* update stats */
      this.criteriaStats.allWkst = (val || []).length === this.wkstIdLists.length;
    },
    selectedTaxStatusTypeList(val) {
      this.criteria.taxStatusType = val;
    },
    selectedTaxDistricts(val) {
      this.criteria.taxDistricts = val;
      /* update stats */
      this.criteriaStats.allTaxDistricts = (val || []).length === this.taxDistrictList.length;
    },
    selectedTaxFees(val) {
      this.criteria.taxFees = val;
      /* update stats */
      this.criteriaStats.allTaxFees = (val || []).length === this.taxFeesList.length;
    },
    selectedTaxStatus(val) {
      this.criteria.taxStatusList = val;
      /* update stats */
      this.criteriaStats.allTaxStatus = (val || []).length === this.taxStatusList.length;
    },
    loadTransactionType() {
      this.criteria.transactionType = this.mapCollectionVal(this.transactionIdList, 'value');
      this.criteriaStats.allTrasactionType = true;
    },
    loadPaymentType() {
      this.criteria.paymentType = this.mapCollectionVal(this.paymentIdList, 'name');
      this.criteriaStats.allPaymentTypes = true;
    },
    loadPaymentTypeWithoutTaxPayment() {
      const allCmnPaymentTypes = (this.cmnPaymentTypes || []);
      const allPaymentTypes = [];
      const itemList = [];
      // eslint-disable-next-line array-callback-return
      allCmnPaymentTypes.map((item, key) => {
        if (item.name !== 'TAXPAYMENT') {
          allPaymentTypes.push({ value: item.name, label: `${key + 1} ${item.name}` });
          itemList.push(item.name);
        }
      });
      this.paymentWithoutTaxPaymentIdList = allPaymentTypes;
      this.criteria.paymentTypeWithoutTaxPayment = itemList;
    },
    loadPaymentModes() {
      this.criteria.paymentModeList = this.mapCollectionVal(this.paymentModeList, 'name');
      this.criteriaStats.allPaymentModes = true;
    },
    loadTaxType() {
      this.criteria.taxTypes = this.mapCollectionVal(this.taxTypeIdList, 'name');
      this.criteriaStats.allTaxTypes = true;
    },
    loadTaxStatusType() {
      const transferItem = this.statusTypes.find((el) => el.description === 'Transfer');
      this.criteria.taxStatusType = transferItem ? [transferItem.name] : [];
    },
    selectedTaxTypes(val) {
      this.criteria.taxTypes = val;
      /* update stats */
      this.criteriaStats.allTaxTypes = (val || []).length === this.taxTypeIdList.length;
    },
    selectedCmnPaymentTypes(val) {
      this.criteria.cmnPaymentTypes = val;
    },
    loadTaxDistricts() {
      const criteria = {};
      this.loadTaxDistrict({ criteria, baseCrudKey: taxDistrictBaseCrudKey }).then(() => {
        this.criteria.taxDistricts = this.mapCollectionVal(this.taxDistrictList, 'districtCode');
        /* Set select-all */
        this.criteriaStats.allTaxDistricts = true;
      });
    },
    loadTaxfeeMaster() {
      const criteria = { sortBy: [{ column: 'feeNumber', direction: 'asc' }] };
      this.loadTaxFeeMasterTypes({ criteria, baseCrudKey: taxFeeMAsterBaseCrudKey }).then(() => {
        this.criteria.taxFees = this.mapCollectionVal(this.taxFeesList, 'feeNumber');
        /* Set select-all */
        this.criteriaStats.allTaxFees = true;
      });
    },
    async loadLatestCCDateFromCC() {
      const ccDate = await this.loadLatestCCDate();
      if (ccDate) {
        this.criteria.fromCCDate = toShortDate(ccDate);
        this.criteria.toCCDate = toShortDate(ccDate);
      } else {
        this.criteria.fromCCDate = toShortDate(this.todaysDate);
        this.criteria.toCCDate = toShortDate(this.todaysDate);
      }
      this.criteria.fromSystemDate = undefined;
      this.criteria.toSystemDate = undefined;
    },
    initCriteria() {
      this.criteria.fromDate = toShortDate(this.todaysDate);
      this.criteria.toDate = toShortDate(this.todaysDate);

      this.criteria.fromPaymentDate = toShortDate(this.todaysDate);
      this.criteria.toPaymentDate = toShortDate(this.todaysDate);
    },
    initSystemDate() {
      this.criteria.fromSystemDate = toShortDate(this.todaysDate);
      this.criteria.toSystemDate = toShortDate(this.todaysDate);
      this.criteria.fromCCDate = undefined;
      this.criteria.toCCDate = undefined;
    },
    changeDateType() {
      if (this.selectedDateType === 'cc') {
        this.loadLatestCCDateFromCC();
      } else if (this.selectedDateType === 'business') {
        this.initSystemDate();
      } else if (this.selectedDateType === 'payment') {
        this.initCriteria();

        // Initialize payment date if needed
        // You can add any specific initialization logic here
      }
    },
    loadExcludedWorkstations() {
      // Initialize excluded workstations with the ones from paymentSetting
      // This will show all workstations but have the excluded ones pre-selected
      if (this.paymentSettingItem.excludeWkst && this.paymentSettingItem.excludeWkst.length > 0) {
        this.criteria.excludedWkst = [...this.paymentSettingItem.excludeWkst];
      } else {
        this.criteria.excludedWkst = [];
      }
    },
    selectedExcludedWkstList(val) {
      this.criteria.excludedWkst = val;
    },
  },
};

</script>
